import { BTaxAccountStatus } from '@egovsolutions/angular-egov-api/btax/internal/basic-models';
export * from '@egovsolutions/angular-egov-api/btax/internal/basic-models';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

const BTAX_BILL_CART_ITEM_TYPE = 'btax';
const BTAX_ACCOUNT_CART_ITEM_TYPE = 'btax-account';

/* eslint-disable */
class BTaxFakeEntities {
    constructor() {
        this.createdBills = {};
        this.createdAccounts = {};
        this.billsInCart = [];
        this.partialAmounts = new Map();
    }
    createAccountSuite(accountNumber, currentTaxYear, query, allowDue = true) {
        const account = this.createAccount(accountNumber);
        accountNumber = account.accountNumber;
        let history = this.createAccountHistory(accountNumber, account.owner || undefined, allowDue);
        history.sort((a, b) => b.taxYear - a.taxYear);
        account.bills = history.map(bill => bill.id);
        account.billsWithABalance = history.filter(bill => bill.due).map(bill => bill.id);
        account.due =
            {
                total: history.reduce((reduced, bill) => reduced + bill.due, 0),
                years: history.reduce((reduced, bill) => reduced + bill.due ? 1 : 0, 0),
            };
        const latestYear = history.map((bill) => bill.taxYear).reduce((reduced, current) => current > reduced ? current : reduced, 0);
        if (currentTaxYear === undefined)
            currentTaxYear = latestYear;
        let bill = history.find(bill => bill.taxYear == latestYear);
        if (bill) {
            bill = { ...bill };
            history = history.map(b => b.taxYear != currentTaxYear ? b : bill);
        }
        return { account, bills: history, latestYear };
    }
    createAccount(accountNumber) {
        const businessName = this.createBusinessName();
        const fictitiousName = Math.random() < .2 ? ('THE LAND OF ' + businessName) : null;
        const defaultAccount = {
            accountNumber: accountNumber || this.createAccountNumber(),
            status: BTaxAccountStatus.ACTIVE,
            businessName,
            fictitiousName,
            owner: this.createBusinessOwnerName(),
            startDate: 1000 * 60 * 60 * 24 * 365 * (20 + Math.random() * 30),
            businessAddress: this.createAddress(businessName),
            mailingAddress: this.createAddress(businessName),
            exemptionStatus: this.createExemptionStatus(),
            typesOfBusiness: this.createTypeOfBusinesses(),
            autoDraftType: Math.random() < .5 ? 'regular' : 'installments',
            due: Math.random() < .3
                ? { years: 0, total: 0 }
                : {
                    years: Math.round(7 * Math.random()),
                    total: Math.round(100000 * Math.random()) / 100,
                },
            renewalNoticeUrl: 'https://www.google.com/',
            paymentBlocked: Math.random() < .2,
            billsWithABalance: []
        };
        const existingAccount = accountNumber && this.createdAccounts[accountNumber];
        const finalAccount = existingAccount ? { ...defaultAccount, ...existingAccount } : defaultAccount;
        this.createdAccounts[finalAccount.accountNumber] = finalAccount;
        return finalAccount;
    }
    createExemptionStatus(allowNone = true) {
        if (allowNone && Math.random() < 1 / 10)
            return null;
        switch (Math.floor(Math.random() * 9)) {
            case 0: return ['Charitable'];
            case 1: return ['Agricultural'];
            case 2: return ['Religious'];
            case 3: return ['OutOfCountyReceipt'];
            case 4: return ['HonorablyDischargedVeteranSpouse'];
            case 5: return ['WidowOrWidowerOfHonorablyDischargedVeteran'];
            case 6: return ['IncomeBased'];
            case 7: return ['Indigent'];
            case 8:
            default: return ['AssistanceBased'];
        }
    }
    createBusinessName(uppercasedQuery) {
        if (uppercasedQuery) {
            switch (Math.floor(Math.random() * 10)) {
                case 0: return 'THE ' + uppercasedQuery + ' GROUP';
                case 1: return uppercasedQuery + ' CLEANING SERVICE & MORE';
                case 2: return uppercasedQuery + ' COURIER';
                case 3: return uppercasedQuery + ' RENEWING TOUCH MASSAGE THERAPY INC';
                case 4: return 'THE ' + uppercasedQuery + ' CLINIC';
                case 5: return uppercasedQuery + ' ASSOCIATES MDPA';
                case 6: return uppercasedQuery;
                case 7: return 'CENTER FOR' + uppercasedQuery + ' CARE & RESEARCH';
                case 8: return uppercasedQuery + ' HOUSE DOCTOR';
                case 9:
                default: return uppercasedQuery + ' PROPERTIES OF POLK COUNTY';
            }
        }
        else {
            const businessNameOptions = [
                'THE HOLLINGSWORTH GROUP INC',
                'SOUTHERN LAND SURVEYORS INC',
                'MATTHEW B WERD',
                'THE HAIR DESIGNERS',
                'THE HAIR AFFAIR',
                'THE STRAWBERRY PATCH',
                'FOR THE RECORD',
                'THE ARGOSY',
                'BARBER BROTHERS HAIRSTYLING INC',
                'THE VILLA BEAUTY BOX',
                'THE STYLIZER',
                'THE HANDYMAN',
                'THE STYLE SHOP',
                'PARK AVENUE THE HAIR PLACE',
                'THE PARLOUR INC OF LAKELAND',
                'THE RIDGE',
                'SOUTHERN UTILITY SERVICE',
                'THE HAIR SHANTY',
                'ATHENIAN BREAKFAST & BURGERS',
                'ADAMS BROTHERS CABINETRY INC',
                'THE RESIDENCE RETIREMENT CENTER INC',
                'THE COLINAS GROUP INC',
                'THE UPS STORE',
                'THE HARBOR LLC',
                'ADVENTHEALTH MEDICAL GROUP GASTROENTEROLOGY AND',
                'KOVACS BROTHERS INC',
                'HOME DEPOT, THE #6324',
                'SOUTHERN SETTINGS',
                'SOUTHERN LANDSCAPING & IRRIGATION SYSTEMS INC',
                'POLIN BROTHERS FLOOR COVERING, INC',
                'TWIN BROTHERS FOOD MART',
                'THE GRILLE',
                'HANGER PROSTHETICS & ORTHOTICS EAST INC',
                'THE GARDENS OF LAKE ALFERD',
                'NAILS BY HEATHER',
                'THE MINUTE MAID CO',
                'THE OFFICE PUB & LOUNGE INC',
                'STEINGRABER GRACE',
                'SOUTHERN MACHINERY CORP',
                'THE GROVES CENTER',
                'DAVID ETHERINGTON',
            ];
            return businessNameOptions[Math.floor(Math.random() * businessNameOptions.length)];
        }
    }
    createBusinessOwnerName() {
        const ownerOptions = [
            'ABLES GHISLAINE',
            'AUGUSTIN MAGDA JULIANA',
            'VARGAS THEODORE + MITSY',
            'BAY STREAM LLC',
            'TURNER MEMORIAL',
            'MICHAEL YVROSE ET AL',
            'EBAAR/JET',
            'CHILLEMI JOHN C TRS',
            'WIBORG RUBY TRUSTEE OF',
            'HAYS RALPH L',
            'SISULAK CARMEN S',
            'PAVIA WILLIAM',
            'THERING SELBY J TRUST',
            'PROUD SANTIAGO FRANCISCO L',
            'SOSA RACHEL G ET AL +',
            'OSBORNE MARIE J',
            'CAGLE FAINA',
            'GORBACH ANNA MARIE',
            'FEENEY PLACID DEVELOPMENT CORP INC',
            'LAKE PROPERTIES OF BUCKHORN LLC',
            'PRIME STEPHEN C',
            'WEEKS DONALD B TRUSTEE',
            'SOLDINI ELSIE P',
            'HOWE MANVILLA ANN',
            'EVANS ELMER D',
            'SHOCKLEY NANCY',
            'RICARDO BETTY J',
            'SNYDER PINAN MARGARET',
            'SALAZAR CORP INC',
            'FEO RICKIE W',
            'NORTHCUTT ANDY P',
            'JACOME LILLIAN',
            'KOSIER WALTER M',
            'MIRASKY JODY',
            'GREGORY WILLIAM P',
            'HOLTON RASHID',
            'KHAN THOMAS',
            'STEINGRABER GRACE',
            'BUTCHER WILLIAM J',
            'BOHLER TIMOTHY J',
            'SULLIVAN MILTON F',
        ];
        return ownerOptions[Math.floor(Math.random() * ownerOptions.length)];
    }
    createAddress(name) {
        return {
            name: Math.random() < .5 ? name : this.createBusinessOwnerName(),
            addressLine1: this.createAddressLine1(),
            city: this.createAddressCity(),
            state: 'FL',
            zip: `${Math.floor(10000 + 89999 * Math.random())}`,
            countryIsUS: true,
        };
    }
    createAddressLine1() {
        const streetNames = [
            'LAKE MORTON DR',
            'EDGEWOOD DR',
            'FLORIDA AVE',
            'CYPRESS GARDENS RD #B',
            'LAKE HOWARD DR',
            'SE K AVE',
            'LAKELAND HILLS BLVD',
            'DORIS DR',
            'EASTON DR',
            'COURTLAND AVE',
            'FLORIDA AVE',
            'EASTON DR',
            'SE AVE K',
            'NEW TAMPA HWY',
            '1ST ST',
            'FLORIDA AVE LAKELAND',
            'AVENUE K SE',
            'GORBACH ANNA MARIE',
            'PARK AVE',
            'LAKE SHORE WAY',
            '29TH ST',
            'MISSISSIPPI AVE',
            'CYPRESS GARDENS RD',
            'LUCERNE PARK RD',
            'SW 3RD ST',
            'DISMUKE DR',
            'VAN FLEET DR',
            'PARK AVE',
            'OLD HIGHWAY',
            'N HWY',
            'AVENUE L SE',
            'HARDEN BLVD',
            'MARVELINE DR',
            'EDGEWOOD DR',
            'HWY 27',
            'MONROE CT',
            'KHAN THOMAS',
            '11TH ST',
            'OLD HIGHWAY',
            'FLORIDA AVE',
            '17TH ST',
        ];
        return Math.round(100 + Math.random() * (3000)) + ' ' + streetNames[Math.floor(Math.random() * streetNames.length)];
    }
    createAddressCity() {
        const cityOptions = [
            'LAKELAND',
            'WINTER HAVEN',
            'AUBURNDALE',
            'BARTOW',
            'DAVENPORT',
            'MULBERRY',
            'POINCIANA',
            'HAINES CITY',
            'FROSTPROOF',
        ];
        return cityOptions[Math.floor(Math.random() * cityOptions.length)];
    }
    createTypeOfBusinesses() {
        const typeOfBusinessOptions = [
            {
                code: '540010',
                description: 'ARCHITECT'
            },
            {
                code: '810000',
                description: 'LTD OTHER SERVICES'
            },
            {
                code: '540020',
                description: 'ATTORNEY'
            },
            {
                code: '540060',
                description: 'CERTIFIED PUBLIC ACCOUNTANT'
            },
            {
                code: '480000',
                description: 'LTD TRANSPORTATION'
            },
            {
                code: '620290',
                description: 'MASSAGE THERAPIST'
            },
            {
                code: '620440',
                description: 'PHYSICIAN'
            },
            {
                code: '620000',
                description: 'LTD HEALTHCARE RELATED ACTIVITY'
            },
            {
                code: '920000',
                description: 'LTD PUBLIC SERVICE'
            },
            {
                code: '710000',
                description: 'LTD ART ENTERTAINMENT RECREATION'
            },
        ];
        const amount = Math.random() < .2 ? 3 : 1;
        const typesOfBusiness = typeOfBusinessOptions.concat([]);
        while (typesOfBusiness.length > amount)
            typesOfBusiness.splice(Math.floor(Math.random() * typesOfBusiness.length));
        return typesOfBusiness;
    }
    createAccountNumber() {
        return `${Math.round(9999999 * Math.random())}`;
    }
    createAccountHistory(accountNumber, owner, allowDue = true) {
        const history = [];
        if (accountNumber === undefined)
            accountNumber = this.createAccountNumber();
        for (let i = 0; i < 10; i++) {
            const bill = this.createBill(accountNumber, owner, i, allowDue);
            history.push(bill);
        }
        return history;
    }
    createBill(accountNumber, owner, i, allowDue = true) {
        const doInstallments = true;
        const amount = Math.round(20000 * Math.random()) / 100;
        const paid = i < 5 || !allowDue;
        const hasInstallments = doInstallments && i == 5 && false;
        const due = paid ? 0 : (hasInstallments ? amount / 3 * 2 : amount);
        const payor = i < 2 ? 'MIRTHA BUSNELLI' : owner;
        let payments;
        if (paid) {
            payments = [this.createPayment(amount, payor || null)];
        }
        else if (hasInstallments) {
            payments = [];
            for (let j = 0; j < 3; j++)
                payments.push(this.createPayment(amount / 4, payor || null));
        }
        const billId = `${accountNumber}-00${i}`;
        const defaultBill = {
            id: billId,
            accountNumber,
            taxYear: 2010 + i,
            owner,
            paid,
            due,
            amountPaid: amount - due,
            payments,
        };
        const existingBill = this.createdBills[billId];
        const finalBill = existingBill ? { ...defaultBill, ...existingBill } : defaultBill;
        this.createdBills[finalBill.id] = finalBill;
        return finalBill;
    }
    createPayment(amount, payor) {
        return ({
            receipt: 1000000000 + Math.floor(Math.random() * 999999999) + '',
            status: 'Complete',
            amount,
            payor: payor || '',
            date: (2017 + Math.round(Math.random() * 2)) + '-' + (1 + Math.round(Math.random() * 11)) + '-' + (1 + Math.round(Math.random() * 27)),
            printUrl: 'https://www.google.com/'
        });
    }
    turnBillIntoCartItem(bill) {
        const itemId = `${BTAX_BILL_CART_ITEM_TYPE}-${bill.id}`;
        return {
            type: BTAX_BILL_CART_ITEM_TYPE,
            id: itemId,
            amount: bill.due,
            partialAmount: this.partialAmounts?.get(bill.id),
            billId: bill.id,
            accountNumber: bill.accountNumber,
        };
    }
    newCartItemsAndExisting(newItems) {
        const allItemsWithDuplicates = this.billsInCart
            .map(id => this.createdBills[id])
            .filter(bill => !!bill)
            .map(bill => this.turnBillIntoCartItem(bill))
            .concat(newItems);
        const allItemsUniqueIds = new Set(allItemsWithDuplicates.map(item => item.id));
        return Array.from(allItemsUniqueIds).map(id => allItemsWithDuplicates.find(item => item.id == id));
    }
    getGrandTotalWithoutFeesForBills(bills) {
        return bills.reduce((prev, curr) => prev + (curr.partialAmount || curr.amount), 0);
    }
}
BTaxFakeEntities.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: BTaxFakeEntities, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BTaxFakeEntities.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: BTaxFakeEntities, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: BTaxFakeEntities, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BTAX_ACCOUNT_CART_ITEM_TYPE, BTAX_BILL_CART_ITEM_TYPE, BTaxFakeEntities };
